module.exports = __webpack_public_path__ + "img/1212b_1.b884a35b.jpg";